import { Expose } from "class-transformer";
import type { ICmsSubscription } from "./cms-subscription.entity.interface";
import type { SubscriptionKind } from "../../enums/subscription-kind.enum";

export class CmsSubscription implements ICmsSubscription {
  @Expose()
  externalProviderCode!: string;

  @Expose()
  order!: number;

  @Expose()
  kind!: SubscriptionKind;

  @Expose()
  pricingPageDescription!: string;

  @Expose()
  hasAI!: boolean;
}
